import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "message-item__row"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "message-item__avatar-initials"
}
const _hoisted_4 = {
  key: 1,
  class: "message-item__avatar message-item__avatar--own"
}
const _hoisted_5 = { class: "message-item__stack" }
const _hoisted_6 = {
  key: 0,
  class: "message-item__meta"
}
const _hoisted_7 = { class: "message-item__meta-time" }
const _hoisted_8 = {
  key: 1,
  class: "message-item__subject"
}
const _hoisted_9 = {
  key: 2,
  class: "message-item__event"
}
const _hoisted_10 = {
  key: 3,
  class: "message-item__quoted"
}
const _hoisted_11 = { class: "message-item__quoted-header" }
const _hoisted_12 = {
  key: 0,
  class: "message-item__quoted-sender"
}
const _hoisted_13 = {
  key: 0,
  class: "message-item__quoted-text"
}
const _hoisted_14 = {
  key: 1,
  class: "message-item__quoted-attachments"
}
const _hoisted_15 = {
  key: 4,
  class: "message-item__body message-item__body--deleted"
}
const _hoisted_16 = {
  key: 5,
  class: "message-item__body message-item__body--unsupported"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 7,
  class: "message-item__attachments"
}
const _hoisted_19 = {
  key: 8,
  class: "message-item__reactions"
}
const _hoisted_20 = ["title", "onClick"]
const _hoisted_21 = { class: "message-item__reaction-emoji" }
const _hoisted_22 = {
  key: 9,
  class: "message-item__type-badge"
}
const _hoisted_23 = {
  key: 10,
  class: "message-item__attendee-type-badge"
}
const _hoisted_24 = {
  key: 11,
  class: "message-item__edited"
}
const _hoisted_25 = {
  key: 1,
  class: "message-item__original-content"
}
const _hoisted_26 = {
  key: 0,
  class: "message-item__read-time message-item__read-time--inline"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 1,
  class: "message-item__read-avatar-initials"
}
const _hoisted_29 = { class: "message-item__actions message-item__actions--hover" }
const _hoisted_30 = {
  key: 1,
  class: "message-item__stack"
}
const _hoisted_31 = {
  key: 0,
  class: "message-item__sender"
}
const _hoisted_32 = {
  key: 1,
  class: "message-item__subject"
}
const _hoisted_33 = {
  key: 2,
  class: "message-item__event"
}
const _hoisted_34 = {
  key: 3,
  class: "message-item__quoted"
}
const _hoisted_35 = { class: "message-item__quoted-header" }
const _hoisted_36 = {
  key: 0,
  class: "message-item__quoted-sender"
}
const _hoisted_37 = {
  key: 0,
  class: "message-item__quoted-text"
}
const _hoisted_38 = {
  key: 1,
  class: "message-item__quoted-attachments"
}
const _hoisted_39 = {
  key: 4,
  class: "message-item__body message-item__body--deleted"
}
const _hoisted_40 = {
  key: 5,
  class: "message-item__body message-item__body--unsupported"
}
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = {
  key: 7,
  class: "message-item__attachments"
}
const _hoisted_43 = {
  key: 8,
  class: "message-item__type-badge"
}
const _hoisted_44 = {
  key: 9,
  class: "message-item__attendee-type-badge"
}
const _hoisted_45 = {
  key: 10,
  class: "message-item__reactions"
}
const _hoisted_46 = { class: "message-item__reaction-emoji" }
const _hoisted_47 = {
  key: 11,
  class: "message-item__edited"
}
const _hoisted_48 = {
  key: 1,
  class: "message-item__original-content"
}
const _hoisted_49 = { class: "message-item__footer" }
const _hoisted_50 = { class: "message-item__timestamp" }
const _hoisted_51 = {
  key: 0,
  class: "message-item__status"
}
const _hoisted_52 = { class: "message-item__actions" }
const _hoisted_53 = {
  key: 2,
  class: "message-item__read-time"
}
const _hoisted_54 = ["src"]
const _hoisted_55 = {
  key: 1,
  class: "message-item__read-avatar-initials"
}

import type { Message, ChatParticipant } from "@/dtos/Unipile.dto";
import {
  formatMessageContent,
  getMaxMessageWidth,
  getPlatformColors,
  type Platform,
} from "@/utils/messageFormatters";
import { formatMessageTimestamp, getMessageStatus } from "@/utils/messageStatus";
import { Icon } from "@iconify/vue";
import { computed, ref } from "vue";
import AttachmentPreview from "./AttachmentPreview.vue";
import ImageLightbox from "./ImageLightbox.vue";
import MessageReactionPicker from "./MessageReactionPicker.vue";

interface Props {
  message: Message;
  platform?: Platform;
  showSender?: boolean;
  showReadReceipts?: boolean;
  participants?: ChatParticipant[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageItem',
  props: {
    message: {},
    platform: { default: undefined },
    showSender: { type: Boolean, default: true },
    showReadReceipts: { type: Boolean, default: false },
    participants: {}
  },
  emits: ["reply", "ai-reply", "ai-followup", "forward", "delete", "react", "remove-reaction"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showOriginal = ref(false);
const showImageLightbox = ref(false);
const lightboxImages = ref<string[]>([]);
const lightboxCurrentIndex = ref(0);
const showReactionPicker = ref(false);
const reactButtonRef = ref<HTMLElement | null>(null);

const onReactionSelect = (emoji: string) => {
  emit("react", emoji);
  showReactionPicker.value = false;
};

const isChatPlatform = computed(() => {
  return props.platform === "whatsapp" || props.platform === "linkedin" || props.platform === "sms";
});

const metaDisplayName = computed(() => {
  if (props.message.isOwn) return "Me";
  return props.message.senderName || "Unnamed";
});

// Avatar helpers
const avatarUrl = computed(() => {
  if (props.message.isOwn) return null;
  // Try to find participant avatar
  if (props.participants && props.message.senderId) {
    const participant = props.participants.find(
      (p) => p.id === props.message.senderId || p.providerUserId === props.message.senderId
    );
    if (participant?.avatar || participant?.picture_url) {
      return participant.avatar || participant.picture_url;
    }
  }
  return null;
});

const avatarInitials = computed(() => {
  if (props.message.isOwn) return "Me";
  const name = props.message.senderName || "U";
  const parts = name.split(" ");
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
});

// Generate a consistent color from a name
const colorFromName = (name: string): string => {
  const colors = ["#6366f1", "#8b5cf6", "#ec4899", "#f59e0b", "#10b981", "#3b82f6", "#ef4444"];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
};

const avatarColor = computed(() => {
  if (props.message.isOwn) return "#3e3efe";
  return colorFromName(props.message.senderName || "U");
});

// The contact (non-self participant) whose read receipt is shown on our own messages
const contactParticipant = computed(() => {
  const readBy = props.message.readReceipts?.[0]?.readBy;
  if (readBy) {
    const reader = props.participants?.find((p) => p.providerUserId === readBy || p.id === readBy);
    if (reader) return reader;
  }
  return props.participants?.find((p) => !p.is_self) || null;
});

const contactAvatarUrl = computed(() => {
  const contact = contactParticipant.value;
  return contact?.avatar || contact?.picture_url || null;
});

const contactInitials = computed(() => {
  const name = contactParticipant.value?.name || "U";
  const parts = name.trim().split(" ").filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
});

const contactColor = computed(() => {
  const name = contactParticipant.value?.name || "U";
  return colorFromName(name);
});

const statusInfo = computed(() => {
  if (!props.platform || !props.message.isOwn) {
    return { status: "sent" as const, icon: "", color: "", label: "" };
  }
  const platform = props.platform;
  if (platform === "whatsapp" || platform === "linkedin") {
    return getMessageStatus(props.message, platform);
  }
  return { status: "sent" as const, icon: "", color: "", label: "" };
});

const platformColors = computed(() => {
  if (!props.platform) return null;
  return getPlatformColors(props.platform);
});

const bubbleStyle = computed(() => {
  if (!platformColors.value) return {};
  if (props.message.isOwn) {
    return {
      backgroundColor: platformColors.value.outgoing,
      color: platformColors.value.outgoingText,
      maxWidth: getMaxMessageWidth(props.platform || "whatsapp"),
    };
  } else {
    return {
      backgroundColor: platformColors.value.incoming,
      color: platformColors.value.incomingText,
      maxWidth: getMaxMessageWidth(props.platform || "whatsapp"),
    };
  }
});

const formattedContent = computed(() => {
  if (!props.message.text) return "";
  if (!props.platform) return props.message.text;

  if (props.message.text.includes("<a href=") || props.message.text.includes('<a href="')) {
    return props.message.text;
  }

  return formatMessageContent(props.message.text, props.platform);
});

const isHtmlContent = computed(() => {
  return formattedContent.value !== props.message.text;
});

const hasEmptyContent = computed(() => {
  const hasText = props.message.text && props.message.text.trim().length > 0;
  const hasAttachments = props.message.attachments && props.message.attachments.length > 0;

  return !hasText && !hasAttachments && !props.message.isEvent && !props.message.deleted;
});

// Get message ID for attachment resolution
const messageId = computed(() => {
  return props.message.id || "";
});

// Helper: create attachment URL for lightbox
const resolveAttachmentUrl = (attachment: any): string | null => {
  if (!attachment.url || attachment.unavailable) return null;

  if (attachment.url.startsWith("att://") && messageId.value && attachment.id) {
    return `/unipile/messages/${messageId.value}/attachments/${attachment.id}`;
  }

  return attachment.url;
};

// Collect all image URLs from message for lightbox
const allImageUrls = computed(() => {
  const urls: string[] = [];

  // Images from main attachments
  if (props.message.attachments) {
    props.message.attachments
      .filter((att) => att.type === "img" && att.url && !att.unavailable)
      .forEach((att) => {
        const url = resolveAttachmentUrl(att);
        if (url) urls.push(url);
      });
  }

  // Images from quoted message attachments
  if (props.message.quoted?.attachments) {
    props.message.quoted.attachments
      .filter((att) => att.type === "img" && att.url && !att.unavailable)
      .forEach((att) => {
        const url = resolveAttachmentUrl(att);
        if (url) urls.push(url);
      });
  }

  return urls;
});

// Handle image click - open lightbox
const handleImageClick = (url: string, attachment: any) => {
  const imageUrls = allImageUrls.value;
  if (imageUrls.length === 0) return;

  let index = imageUrls.findIndex((u) => u === url);

  // If not found, try to match by attachment ID
  if (index < 0 && attachment.id) {
    index = imageUrls.findIndex((u) => u.includes(attachment.id));
  }

  lightboxCurrentIndex.value = index >= 0 ? index : 0;
  lightboxImages.value = imageUrls;
  showImageLightbox.value = true;
};

const closeImageLightbox = () => {
  showImageLightbox.value = false;
};

const formatChatTime = (timestamp: string): string => {
  const date = new Date(timestamp);
  const dayName = date.toLocaleDateString("en-US", { weekday: "short" });
  const time = date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
  return `${dayName}, ${time}`;
};

const formatTimestamp = (timestamp: string): string => {
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return "Just now";

  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const getEventIcon = (eventType?: number): string => {
  switch (eventType) {
    case 1:
    case 2:
      return "mdi:emoticon-happy-outline";
    case 3:
      return "mdi:account-group";
    case 4:
      return "mdi:rename-box";
    case 5:
      return "mdi:account-plus";
    case 6:
      return "mdi:account-minus";
    case 7:
      return "mdi:account-arrow-left";
    case 8:
    case 9:
      return "mdi:phone-missed";
    default:
      return "mdi:information-outline";
  }
};

const getEventText = (eventType?: number): string => {
  switch (eventType) {
    case 1:
      return "A user reacted to a message";
    case 2:
      return "A user reacted to your message";
    case 3:
      return "The group was created";
    case 4:
      return "The group title was changed";
    case 5:
      return "A new participant was added to the group";
    case 6:
      return "A participant was removed from the group";
    case 7:
      return "A participant left the group";
    case 8:
      return "Missed voice call";
    case 9:
      return "Missed audio call";
    default:
      return "System event";
  }
};

const quotedSenderName = computed(() => {
  if (!props.message.quoted) return null;
  if (props.message.quoted.senderName) {
    return props.message.quoted.senderName;
  }
  if (props.message.quoted.sender_id && props.participants) {
    const participant = props.participants.find(
      (p) => p.providerUserId === props.message.quoted?.sender_id
    );
    if (participant?.name) {
      return participant.name;
    }
  }
  return props.message.quoted.sender_id || "Unknown";
});

return (_ctx: any,_cache: any) => {
  return (!__props.message.hidden)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["message-item", {
      'message-item--own': __props.message.isOwn,
      'message-item--event': __props.message.isEvent,
      'message-item--deleted': __props.message.deleted,
      'message-item--pending': __props.message.isPending,
      [`message-item--${__props.platform}`]: __props.platform,
    }])
      }, [
        (isChatPlatform.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (!__props.message.isOwn)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "message-item__avatar",
                    style: _normalizeStyle({ backgroundColor: avatarColor.value })
                  }, [
                    (avatarUrl.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: avatarUrl.value,
                          alt: metaDisplayName.value,
                          class: "message-item__avatar-img"
                        }, null, 8, _hoisted_2))
                      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(avatarInitials.value), 1))
                  ], 4))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("span", { class: "message-item__avatar-initials" }, "Me", -1)
                  ]))])),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["message-item__bubble", {
            'message-item__bubble--outgoing': __props.message.isOwn,
            'message-item__bubble--incoming': !__props.message.isOwn,
            [`message-item__bubble--${__props.platform}`]: __props.platform,
          }]),
                  style: _normalizeStyle(bubbleStyle.value)
                }, [
                  (__props.showSender)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("span", {
                          class: "message-item__meta-name",
                          style: _normalizeStyle({ color: __props.message.isOwn ? 'inherit' : avatarColor.value })
                        }, _toDisplayString(metaDisplayName.value), 5),
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "message-item__meta-sep" }, "·", -1)),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(formatChatTime(__props.message.timestamp)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.message.subject)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.message.subject), 1))
                    : _createCommentVNode("", true),
                  (__props.message.isEvent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_unref(Icon), {
                          icon: getEventIcon(__props.message.eventType)
                        }, null, 8, ["icon"]),
                        _createElementVNode("span", null, _toDisplayString(getEventText(__props.message.eventType)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.message.quoted && !__props.message.deleted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_unref(Icon), { icon: "mdi:reply" }),
                          (quotedSenderName.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(quotedSenderName.value), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (__props.message.quoted.text)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(__props.message.quoted.text), 1))
                          : _createCommentVNode("", true),
                        (__props.message.quoted.attachments && __props.message.quoted.attachments.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.quoted.attachments, (attachment) => {
                                return (_openBlock(), _createBlock(AttachmentPreview, {
                                  key: attachment.id,
                                  attachment: attachment,
                                  "message-id": messageId.value,
                                  onImageClick: handleImageClick
                                }, null, 8, ["attachment", "message-id"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.message.deleted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_unref(Icon), { icon: "mdi:delete-outline" }),
                        _cache[14] || (_cache[14] = _createElementVNode("span", null, "Message deleted", -1))
                      ]))
                    : (hasEmptyContent.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_unref(Icon), { icon: "mdi:alert-circle-outline" }),
                          _cache[15] || (_cache[15] = _createElementVNode("span", null, "This message type isn't supported. Please check the original platform to view it.", -1))
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 6,
                          class: _normalizeClass(["message-item__body", { 'message-item__body--html': isHtmlContent.value }]),
                          innerHTML: formattedContent.value
                        }, null, 10, _hoisted_17)),
                  (__props.message.attachments && __props.message.attachments.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.attachments, (attachment) => {
                          return (_openBlock(), _createBlock(AttachmentPreview, {
                            key: attachment.id,
                            attachment: attachment,
                            "message-id": messageId.value,
                            onImageClick: handleImageClick
                          }, null, 8, ["attachment", "message-id"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (__props.message.reactions && __props.message.reactions.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.reactions, (reaction, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: _normalizeClass(["message-item__reaction", { 'message-item__reaction--own': reaction.is_sender }]),
                            title: reaction.is_sender ? 'Click to remove your reaction' : undefined,
                            onClick: ($event: any) => (reaction.is_sender && _ctx.$emit('remove-reaction'))
                          }, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(reaction.value), 1)
                          ], 10, _hoisted_20))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (__props.message.message_type === 'INMAIL' || __props.message.messageType === 'inmail')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_unref(Icon), { icon: "mdi:email" }),
                        _cache[16] || (_cache[16] = _createElementVNode("span", null, "InMail", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (__props.message.attendee_type === 'ADMIN')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_unref(Icon), { icon: "mdi:shield-account" }),
                        _cache[17] || (_cache[17] = _createElementVNode("span", null, "Admin", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (__props.message.edited)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_unref(Icon), { icon: "mdi:pencil" }),
                        _cache[18] || (_cache[18] = _createElementVNode("span", null, "Edited", -1)),
                        (__props.message.original)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "message-item__show-original-btn",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (showOriginal.value = !showOriginal.value))
                            }, _toDisplayString(showOriginal.value ? "Hide" : "Show") + " original ", 1))
                          : _createCommentVNode("", true),
                        (showOriginal.value && __props.message.original)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(__props.message.original), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 6),
                (
            __props.message.isOwn &&
            __props.message.readReceipts &&
            __props.message.readReceipts.length > 0 &&
            __props.showReadReceipts
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (__props.platform === 'linkedin')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "message-item__read-avatar",
                            style: _normalizeStyle({ backgroundColor: contactAvatarUrl.value ? 'transparent' : contactColor.value })
                          }, [
                            (contactAvatarUrl.value)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: contactAvatarUrl.value,
                                  alt: "",
                                  class: "message-item__read-avatar-img"
                                }, null, 8, _hoisted_27))
                              : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(contactInitials.value), 1))
                          ], 4))
                        : (_openBlock(), _createBlock(_unref(Icon), {
                            key: 1,
                            icon: "mdi:check-circle",
                            style: { color: '#10b981', fontSize: '0.875rem' }
                          })),
                      _createElementVNode("span", null, "Read " + _toDisplayString(formatTimestamp(__props.message.readReceipts[0].readAt)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", {
                    ref_key: "reactButtonRef",
                    ref: reactButtonRef,
                    class: "message-item__action-icon-btn",
                    type: "button",
                    title: "React",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showReactionPicker.value = !showReactionPicker.value))
                  }, [
                    _createVNode(_unref(Icon), { icon: "mdi:emoticon-happy-outline" })
                  ], 512),
                  _createElementVNode("button", {
                    class: "message-item__action-icon-btn",
                    type: "button",
                    title: "Reply",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reply')))
                  }, [
                    _createVNode(_unref(Icon), { icon: "material-symbols:reply-rounded" })
                  ]),
                  (__props.platform === 'whatsapp')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "message-item__action-icon-btn",
                        type: "button",
                        title: "Forward",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('forward')))
                      }, [
                        _createVNode(_unref(Icon), { icon: "material-symbols:forward-rounded" })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "message-item__action-icon-btn",
                    type: "button",
                    title: "Delete",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('delete')))
                  }, [
                    _createVNode(_unref(Icon), { icon: "mdi:delete-outline" })
                  ])
                ]),
                _createVNode(MessageReactionPicker, {
                  show: showReactionPicker.value,
                  "trigger-el": reactButtonRef.value,
                  onSelect: onReactionSelect,
                  onClose: _cache[5] || (_cache[5] = ($event: any) => (showReactionPicker.value = false))
                }, null, 8, ["show", "trigger-el"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", {
                class: _normalizeClass(["message-item__bubble", {
          'message-item__bubble--outgoing': __props.message.isOwn,
          'message-item__bubble--incoming': !__props.message.isOwn,
          [`message-item__bubble--${__props.platform}`]: __props.platform,
        }]),
                style: _normalizeStyle(bubbleStyle.value)
              }, [
                (!__props.message.isOwn && __props.showSender)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(__props.message.senderName), 1))
                  : _createCommentVNode("", true),
                (__props.message.subject)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(__props.message.subject), 1))
                  : _createCommentVNode("", true),
                (__props.message.isEvent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createVNode(_unref(Icon), {
                        icon: getEventIcon(__props.message.eventType)
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", null, _toDisplayString(getEventText(__props.message.eventType)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (__props.message.quoted && !__props.message.deleted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_unref(Icon), { icon: "mdi:reply" }),
                        (quotedSenderName.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(quotedSenderName.value), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (__props.message.quoted.text)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(__props.message.quoted.text), 1))
                        : _createCommentVNode("", true),
                      (__props.message.quoted.attachments && __props.message.quoted.attachments.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.quoted.attachments, (attachment) => {
                              return (_openBlock(), _createBlock(AttachmentPreview, {
                                key: attachment.id,
                                attachment: attachment,
                                "message-id": messageId.value,
                                onImageClick: handleImageClick
                              }, null, 8, ["attachment", "message-id"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (__props.message.deleted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createVNode(_unref(Icon), { icon: "mdi:delete-outline" }),
                      _cache[19] || (_cache[19] = _createElementVNode("span", null, "Message deleted", -1))
                    ]))
                  : (hasEmptyContent.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createVNode(_unref(Icon), { icon: "mdi:alert-circle-outline" }),
                        _cache[20] || (_cache[20] = _createElementVNode("span", null, "This message type isn't supported. Please check the original platform to view it.", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 6,
                        class: _normalizeClass(["message-item__body", { 'message-item__body--html': isHtmlContent.value }]),
                        innerHTML: formattedContent.value
                      }, null, 10, _hoisted_41)),
                (__props.message.attachments && __props.message.attachments.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.attachments, (attachment) => {
                        return (_openBlock(), _createBlock(AttachmentPreview, {
                          key: attachment.id,
                          attachment: attachment,
                          "message-id": messageId.value,
                          onImageClick: handleImageClick
                        }, null, 8, ["attachment", "message-id"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (__props.message.message_type === 'INMAIL' || __props.message.messageType === 'inmail')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createVNode(_unref(Icon), { icon: "mdi:email" }),
                      _cache[21] || (_cache[21] = _createElementVNode("span", null, "InMail", -1))
                    ]))
                  : _createCommentVNode("", true),
                (__props.message.attendee_type === 'ADMIN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createVNode(_unref(Icon), { icon: "mdi:shield-account" }),
                      _cache[22] || (_cache[22] = _createElementVNode("span", null, "Admin", -1))
                    ]))
                  : _createCommentVNode("", true),
                (__props.message.reactions && __props.message.reactions.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.reactions, (reaction, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "message-item__reaction"
                        }, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(reaction.value), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (__props.message.edited)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createVNode(_unref(Icon), { icon: "mdi:pencil" }),
                      _cache[23] || (_cache[23] = _createElementVNode("span", null, "Edited", -1)),
                      (__props.message.original)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "message-item__show-original-btn",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (showOriginal.value = !showOriginal.value))
                          }, _toDisplayString(showOriginal.value ? "Hide" : "Show") + " original ", 1))
                        : _createCommentVNode("", true),
                      (showOriginal.value && __props.message.original)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(__props.message.original), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(formatMessageTimestamp)(__props.message.timestamp)), 1),
                  (__props.message.isOwn && (statusInfo.value.icon || __props.message.isPending))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                        (__props.message.isPending)
                          ? (_openBlock(), _createBlock(_unref(Icon), {
                              key: 0,
                              icon: "mdi:clock-outline",
                              style: { color: '#9ca3af' },
                              title: "Sending..."
                            }))
                          : (statusInfo.value.icon)
                            ? (_openBlock(), _createBlock(_unref(Icon), {
                                key: 1,
                                icon: statusInfo.value.icon,
                                style: _normalizeStyle({ color: statusInfo.value.color })
                              }, null, 8, ["icon", "style"]))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 6),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("button", {
                  class: "message-item__action-btn",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('reply')))
                }, [
                  _createVNode(_unref(Icon), { icon: "mdi:reply" }),
                  _cache[24] || (_cache[24] = _createTextVNode(" Reply ", -1))
                ]),
                _createElementVNode("button", {
                  class: "message-item__action-btn",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('ai-reply')))
                }, [
                  _createVNode(_unref(Icon), { icon: "mdi:sparkles" }),
                  _cache[25] || (_cache[25] = _createTextVNode(" AI Reply ", -1))
                ]),
                _createElementVNode("button", {
                  class: "message-item__action-btn",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('forward')))
                }, [
                  _createVNode(_unref(Icon), { icon: "mdi:share-variant" }),
                  _cache[26] || (_cache[26] = _createTextVNode(" Forward ", -1))
                ]),
                _createElementVNode("button", {
                  class: "message-item__action-btn",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('delete')))
                }, [
                  _createVNode(_unref(Icon), { icon: "mdi:delete-outline" })
                ])
              ])
            ])),
        (
        !isChatPlatform.value &&
        __props.message.isOwn &&
        __props.message.readReceipts &&
        __props.message.readReceipts.length > 0 &&
        __props.showReadReceipts
      )
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              (__props.platform === 'linkedin')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "message-item__read-avatar",
                    style: _normalizeStyle({ backgroundColor: contactAvatarUrl.value ? 'transparent' : contactColor.value })
                  }, [
                    (contactAvatarUrl.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: contactAvatarUrl.value,
                          alt: "",
                          class: "message-item__read-avatar-img"
                        }, null, 8, _hoisted_54))
                      : (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(contactInitials.value), 1))
                  ], 4))
                : (_openBlock(), _createBlock(_unref(Icon), {
                    key: 1,
                    icon: "mdi:check-circle",
                    style: { color: '#10b981', fontSize: '0.875rem' }
                  })),
              _createElementVNode("span", null, "Read " + _toDisplayString(formatTimestamp(__props.message.readReceipts[0].readAt)), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(ImageLightbox, {
          show: showImageLightbox.value,
          images: lightboxImages.value,
          "current-index": lightboxCurrentIndex.value,
          onClose: closeImageLightbox,
          "onUpdate:currentIndex": _cache[11] || (_cache[11] = (index) => (lightboxCurrentIndex.value = index))
        }, null, 8, ["show", "images", "current-index"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})